import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useMemo } from 'react';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

export const useEstimatedTax = (cartGuid) => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    const updateProvince = ({ provinceId, onSuccess }) => {
        return http.get(`${base}${lang}/carts/${cartGuid}/provincialtaxes/${provinceId}`);
    };
    return useMutation({
        mutationFn: updateProvince,
        onSuccess: (response, variables) => {
            variables.onSuccess(response.data);
        },
        onError: (error, variables, context) => {
            console.log(`${context} ${error}`);
        },
    });
};
